import { Component, Input, OnInit, ViewChild, OnChanges, AfterViewInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ChatService } from 'src/app/services/chat.service';
import { UserService } from 'src/app/services/user.service';
import { Upload } from 'src/app/interfaces/upload';
import { IonContent, ModalController, Platform } from '@ionic/angular';
import { ViewerModalComponent } from 'ngx-ionic-image-viewer';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss'],
})
export class MessageListComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild(IonContent) content: IonContent;
  
  @Input() chatData: any;
  @Input() users: any[];

  @Output() msgAction = new EventEmitter<string>();

  loading: HTMLIonLoadingElement;
  messageList: any[];
  uploads: Upload[] = [];
  scollElement: HTMLElement;
  wheelEventTimeout: any;
  reassignList: any[];

  messageListLength = 20;
  prevMessagesAmount = 20;
  lastPrevQueryAmount = 20;
  loadingPrevMessages = false;

  newMsg: any;
  userID: number;

  markAsReadTimeout: any;
  attachmentFabsVisible = false;

  selectedMessages = [];
  selectionTimer: any;
  longPressTimer: any;

  audioRecording = {
    started: false,
    recorder: null,
    wasCanceled: false,
    file: {
      entry: null,
      media: null,
      name: '',
      path: '',
      pathAbs: ''
    },
    timer: {
      parsed: '00:00',
      seconds: 0,
      interval: null
    }
  };

  colorPerUser = {};

  customAlertOptions: any = {
    header: 'REASIGNAR CONTACTO',
    message: 'Debe seleccionar una persona de contacto',
    translucent: true,
    cssClass: 'contact-selector'
  };

  constructor(
    private chatService: ChatService,
    private userService: UserService,
    private platform: Platform,
    private modalController: ModalController,
    ) { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    console.log('NG ON CHANGES', changes);

    if (changes.chatData && changes.chatData.currentValue !== null && changes.chatData.currentValue !== undefined) {
      if (changes.chatData.previousValue === undefined) {
        this.userID = this.userService.currentUser.id;      
      } 
      
      if (changes.chatData.previousValue === undefined || changes.chatData.previousValue.id !== this.chatData.id) {
        this.getChatMessages();

        this.updateReassignList();
      }
    }
  }

  ngAfterViewInit() {

    window.oncontextmenu = () => false;
  }

  async checkScroll(ev, from, index){

    if (index < this.messageListLength) {
      console.log('srolledFrom: '+from);
      this.content.scrollToBottom(300);
    }
  }

  async getChatMessages() {

    if (this.chatData.id) {
      this.messageList = [];

      this.chatService.getChatMessages(this.chatData.id, this.messageListLength, 0).subscribe((res) => {
        if (!res.error) {

          for(const msg of res.messages) {
            this.handleMessageChange(msg);
          }
        }

        setTimeout(()=>{
          this.checkScroll(null, 'messages+1500', 0);
        },500);

        this.subscribeToScrollTop();

      });
    }
    else {
      setTimeout(()=>{
        this.getChatMessages();
      },1000);
    }
  }

  async getPrevMessages() {
    // if last time it brings less messages then there is no more of those.
    if (!this.loadingPrevMessages && this.lastPrevQueryAmount >= this.prevMessagesAmount) {
      this.loadingPrevMessages = true;
      console.log('entra getPrevMessages', this.lastPrevQueryAmount, this.prevMessagesAmount);

      this.chatService.getChatMessages(this.chatData.id, this.prevMessagesAmount, this.messageList.length).subscribe(
        (result) => {
          if (!result.error) {
            console.log('Prev messages', result.messages);

            this.lastPrevQueryAmount = result.messages.length;

            for(const msg of result.messages) {
              this.handleMessageChange(msg);
            }
          }

          this.loadingPrevMessages = false;
        });
    }    
  }

  handleMessageChange(msg) {
    const existingIdx = this.messageList.findIndex(m => m.id === msg.id);

    if (existingIdx < 0) {
      //this.messageList.push(msg);
      this.insertSorted(this.messageList, msg, (a, b) => {
        return (a.created_at > b.created_at ? -1 : 1);
      });
    }
    else {
      this.messageList[existingIdx] = msg;
    }
  }

  insertSorted(arr, item, comparator?) {
    if (comparator == null) {
        // emulate the default Array.sort() comparator
        comparator = (a, b) => {
          if (typeof a !== 'string') { a = String(a); };
          if (typeof b !== 'string') { b = String(b); };
          return (a > b ? 1 : (a < b ? -1 : 0));
        };
    }

    // get the index we need to insert the item at
    let min = 0;
    let max = arr.length;
    let index = Math.floor((min + max) / 2);
    while (max > min) {
        if (comparator(item, arr[index]) < 0) {
            max = index;
        } else {
            min = index + 1;
        }
        index = Math.floor((min + max) / 2);
    }

    // insert the item
    arr.splice(index, 0, item);
  }  

  msgTrackBy( i: number, el: any ) {
    return el ? el.id : null;
  }

  updateReassignList() {
    this.reassignList = this.users.filter(u => (u.is_member && u.id !== this.chatData.agent.id));
  }

  subscribeToScrollTop() {
    this.content.scrollEvents = true;

    this.content.ionScrollEnd.subscribe((data)=>{
      console.log('ionScrollEnd');
      this.content.getScrollElement().then(scrl=>{
        if (scrl.scrollTop < 10) {
          this.getPrevMessages();
        }
      });
    });
  }

  setEventHandlers() {
    this.platform.pause.subscribe(async () => {
      console.log('Pause event detected');
    });

    this.platform.resume.subscribe(async () => {
      console.log('Resume event detected');
    });
  }

  timeWheelEvent(event) {
    clearTimeout(this.wheelEventTimeout);
    this.wheelEventTimeout = setTimeout(()=>{
      this.checkWheelEvent(event);
    }, 1000);    
  }  

  checkWheelEvent(event) {
    this.content.getScrollElement().then(scrl=>{
      if (event.deltaY < 0 && scrl.scrollTop < 10) {
        this.getPrevMessages();
      }
    });

  }

  getDocName(url) {
    return unescape(url).split('/').pop().split('?').shift();
  }

  downloadFirebaseFile(url) {

    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = (event) => {
      const blob = xhr.response;
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = this.getDocName(url);
      downloadLink.click();
    };
    xhr.open('GET', url);
    xhr.send();

  }

  async openImageViewer(url) {
    const modal = await this.modalController.create({
      component: ViewerModalComponent,
      componentProps: {
        src: url
      },
      cssClass: 'ion-img-viewer',
      keyboardClose: true,
      showBackdrop: true
    });

    return await modal.present();
  }

  logEvent(event){
    console.log(event);
  }

  ngOnDestroy() {
    console.log('DESTROYED MESSAGE LIST');
  }

  reassignContact(e) {
    console.log('reasignar contacto a:', e)

    if (e.detail?.value && e.detail?.value != '') {
      this.chatService.reassignContact(this.chatData.id, this.chatData.agent.id, parseInt(e.detail.value)).subscribe(res => {
        if (!res.error) {
          this.chatService.createMessage(this.chatData.id, 'system', 'CHAT REASIGNADO').subscribe(res => {});
        }
      })
    }
  }
}
